export default "__VITE_ASSET__ecd4c33c__"